var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-sheet',{staticClass:"background-container"},[_c('vue-marquee-slider',{attrs:{"id":"marquee-slider","speed":80000,"space":50,"autoWidth":""}},[_c('p',{staticClass:"font-weight-bold grey--text text--lighten-2 mb-0 text-marquee"},[_vm._v(" FRONTEND ")])]),_c('vue-marquee-slider',{attrs:{"id":"marquee-slider-reverse","reverse":"","speed":80000,"space":50,"autoWidth":""}},[_c('p',{staticClass:"font-weight-bold grey--text text--lighten-2 mb-0 text-marquee"},[_vm._v(" DEVELOPER ")])])],1),_c('v-sheet',{staticClass:"body-container"},[_c('v-sheet',{staticClass:"header-img-container"},[_c('v-img',{staticClass:"img-face",attrs:{"data-aos":"fade-up","height":"200","src":require("../assets/icons/face_1.webp")}})],1),_c('div',[_c('p',{class:{
          'text-body': true,
          'font-weight-bold': true,
          'grey--text': true,
          'text--darken-4': true,
          'mb-0': true,
          'text-center': _vm.$vuetify.breakpoint.xs,
          'text-start': !_vm.$vuetify.breakpoint.xs,
        }},[_vm._v(" "+_vm._s(_vm.$t("hi"))+" ")]),_c('p',{class:{
          'text-name': true,
          'font-weight-bold': true,
          'grey--text': true,
          'text--darken-4': true,
          'mb-0': !_vm.$vuetify.breakpoint.xs,
          'mb-2': _vm.$vuetify.breakpoint.xs,
          'text-center': _vm.$vuetify.breakpoint.xs,
        }},[_c('span',{staticClass:"green--text text--darken-3"},[_vm._v("Melvin")]),_vm._v(" Durán Vega ")])]),_c('div',{staticClass:"chip-header"},[_vm._v("Frontend Developer")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }